import {CHAT_DEFAULT_HOMESERVER_URL, CHAT_DEFAULT_HOMESERVER_DOMAIN, SOCIAL_DEFAULT_SERVICE} from '#/lib/constants'
import {forceLTR} from '#/lib/strings/bidi'

function getHostFromUrl(value: string, fallbackUrl: string): string {
  try {
    return new URL(value).host || new URL(fallbackUrl).host
  } catch {
    try {
      return new URL(fallbackUrl).host
    } catch {
      return fallbackUrl
    }
  }
}

export function normalizeAtprotoIdentifier(
  input: string,
  serviceUrl: string = SOCIAL_DEFAULT_SERVICE,
): string {
  const trimmed = input.trim()
  if (!trimmed) return ''
  let value = trimmed
  if (value.startsWith('@')) value = value.slice(1)
  if (value.includes('@')) return value
  if (value.includes('.')) return value
  const domain = getHostFromUrl(serviceUrl, SOCIAL_DEFAULT_SERVICE)
  return `${value}.${domain}`
}

export function normalizeMatrixIdentifier(
  input: string,
  homeserverUrl: string = CHAT_DEFAULT_HOMESERVER_URL,
): string {
  const trimmed = input.trim()
  if (!trimmed) return ''
  // already a full mxid
  if (trimmed.startsWith('@') && trimmed.includes(':')) return trimmed
  // if it's an email-like string, don't try to "mxid-ify" it
  if (trimmed.includes('@')) return trimmed

  // IMPORTANT:
  // base_url host can differ from the Matrix ID domain (server_name).
  // Example: matrix.org uses base_url=https://matrix-client.matrix.org but mxids are :matrix.org
  let domain = CHAT_DEFAULT_HOMESERVER_DOMAIN
  try {
    const host = new URL(homeserverUrl).host
    if (host && host !== 'matrix-client.matrix.org') {
      domain = host
    }
  } catch {
   // ignore
  }

  return `@${trimmed}:${domain}`
}

export function displayAtproto(handle: string): string {
  const trimmed = handle.trim()
  if (!trimmed) return ''
  const withoutAt = trimmed.startsWith('@') ? trimmed.slice(1) : trimmed
  const local = withoutAt.split('.')[0] || withoutAt
  return forceLTR(`@${local}`)
}

export function displayMatrix(mxid: string): string {
  const trimmed = mxid.trim()
  if (!trimmed) return ''
  const withoutAt = trimmed.startsWith('@') ? trimmed.slice(1) : trimmed
  const local = withoutAt.includes(':')
    ? withoutAt.split(':')[0]
    : withoutAt.includes('@')
      ? withoutAt.split('@')[0]
      : withoutAt
  return forceLTR(`@${local}`)
}
